module.exports = __webpack_public_path__ + "img/logo_nep-dom.png";